/**
 * POS platform options for the PDI managed-network section.
 *
 * PLACEHOLDER LIST pending Michael's authoritative set (issue #37 /
 * demo 2026-07-06). The dropdown scaffold and the "Other" free-text
 * fallback are shippable now; when Michael sends the real list, edit
 * POS_PLATFORM_OPTIONS below (this is the single source of truth).
 *
 * The stored value stays a free-text string end-to-end (PdiPrefs
 * .posPlatform), so the option `value` is just the display name. The
 * "Other" path lets a recipient type a cloud/oddball platform that
 * isn't listed.
 */

export interface PosPlatformOption {
  value: string;
  label: string;
}

// Confirmed by Michael in the 2026-07-13 prod-cutover meeting (~14:59,
// ~56:40): Ruby 2 / Ruby Ci / FlexPay are going away; anything "Ruby"
// becomes Verifone C.I., Commander Edge, or C-18. Radiant stays ("only
// used once but you can leave that"). NRS added ("one that we do work
// with"). More vendors will be added as Michael/Greg onboard POS
// partners; this file stays the single source of truth.
export const POS_PLATFORM_OPTIONS: readonly PosPlatformOption[] = [
  { value: "Verifone C.I.", label: "Verifone C.I." },
  { value: "Verifone Commander", label: "Verifone Commander" },
  { value: "Verifone Commander Edge", label: "Verifone Commander Edge" },
  { value: "Verifone C-18", label: "Verifone C-18" },
  { value: "Gilbarco Passport", label: "Gilbarco Passport" },
  { value: "NCR Radiant", label: "NCR Radiant" },
  { value: "Bulloch BT9000", label: "Bulloch BT9000" },
  { value: "Clover", label: "Clover" },
  {
    value: "NRS (National Retail Solutions)",
    label: "NRS (National Retail Solutions)",
  },
];

// Sentinel option value that switches the field into free-text mode.
// Deliberately not a real platform name so it can't collide with a
// stored value.
export const POS_PLATFORM_OTHER = "__other__";

const KNOWN_POS_VALUES = new Set(POS_PLATFORM_OPTIONS.map((o) => o.value));

/** True when a stored posPlatform value is a manually entered ("Other")
 *  platform rather than one of the known options. Empty is neither. */
export function isOtherPosPlatform(value: string | null | undefined): boolean {
  return !!value && !KNOWN_POS_VALUES.has(value);
}
